import styled from 'styled-components';

export const InputBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px 0;
  width: 270px;
  max-width: 100%;

  label {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: var(--color-text-muted);
  }
`;
